import { getFunctions, httpsCallable } from "firebase/functions";

const functionsInstance = getFunctions();

/**
 * Chama a Cloud Function que altera em lote a oferta de renovação
 * de assinaturas na Guru.
 *
 * @param {string[]} subscriptionIds IDs das assinaturas na Guru (body.id do webhook)
 * @param {string} newOfferId ID da nova oferta de renovação na Guru
 */
export async function updateRenewalOfferBatch(subscriptionIds, newOfferId) {
  const callable = httpsCallable(
    functionsInstance,
    "guruUpdateRenewalOfferBatchHandler"
  );

  const response = await callable({
    subscriptionIds,
    newOfferId,
  });

  return response.data;
}

